<template>
  <transaction-list
    :location="location"
    :transactionService = transactionService
    :productService = productService
    :locationService = locationService
    :showCost = showCost
  ></transaction-list>
</template>
<script>
  import TransactionList from '@/components/Common/Transaction/TransactionList'
  import {mapGetters} from 'vuex'

  export default {
    props: {
      locationService: Object,
      transactionService: Object,
      productService: Object,
      location: Object,
    },

    components: {
      TransactionList
    },

    computed: {
      ...mapGetters('acl', [
        'matchRoles'
      ]),

      showCost () {
        return this.matchRoles(['machine_operation'])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Transaction.vue